interface DateRangeState {
  startDate: Date
  endDate: Date
  key: string
}

type SetStateFunction = (state: DateRangeState[]) => void
type SetDateFunction = (date: string) => void
type SetDateObjectFunction = (date: Date) => void

export const parseAndSetDates = (
  value: string,
  setStartDate: SetDateFunction | null,
  setEndDate: SetDateFunction | null,
  setState: SetStateFunction | null,
  separator: string = ' - ',
  setDateObject?: SetDateObjectFunction
) => {
  const dates = value.split(separator)

  // Handle single date case
  if (setDateObject) {
    const date = new Date(value)
    if (date.getTime()) {
      setDateObject(date)
    }
    return
  }

  // Handle date range case
  // Handle direct state updates if setStartDate and setEndDate are provided
  if (setStartDate && setEndDate) {
    setStartDate(dates[0])
    setEndDate(dates[1])
  }

  // Validate dates
  if (dates[0] && !new Date(dates[0]).getTime()) {
    return
  }
  if (dates[1] && !new Date(dates[1]).getTime()) {
    return
  }

  // Handle array-based state update if setState is provided
  if (setState) {
    const startDateObj = dates[0] ? new Date(dates[0]) : new Date()
    const endDateObj = dates[1] ? new Date(dates[1]) : new Date()

    // Ensure the dates are valid before updating state
    if (startDateObj.getTime() && endDateObj.getTime()) {
      setState([
        {
          startDate: startDateObj,
          endDate: endDateObj,
          key: 'selection',
        },
      ])
    }
  }
}
